<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="$permission.canEdit()"
      unit="角色"
      edit-title
      id-key="RoleId"
      form-label-width="110px"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.getRoleWithMenu"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      save-and-create
      close-on-saved
      @save-create="onSaved"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <!-- <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="角色类型" prop="RoleType">
              <el-select size="mini" v-model="data.RoleType" placeholder="请选择角色类型" clearable>
                <el-option label="平台" :value="0"></el-option>
                <el-option label="商家" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="角色名称" prop="RoleName">
              <el-input v-model="data.RoleName" placeholder="请输入角色名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" prop="Remark">
          <el-input v-model="data.Remark" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <!-- <el-form-item label="数据阅读权限" prop="DataRange" :class="$store.state.isMB?'setMargin':''">
          <el-radio-group v-model="data.DataRange">
            <el-radio :label="0">所有</el-radio>
            <br v-if="$store.state.isMB" />
            <el-radio :label="1">本部门</el-radio>
            <br v-if="$store.state.isMB" />
            <el-radio :label="2">本部门以及下属部门</el-radio>
            <br v-if="$store.state.isMB" />
            <el-radio :label="3">本人</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <div v-if="$store.state.isMB" style="margin-bottom:10px;">功能权限操作</div>
        <el-form-item
          :label="$store.state.isMB?'':'功能操作权限'"
          :label-width="$store.state.isMB?'0':''"
        >
          <menu-list ref="menuList" />
        </el-form-item>
      </template>
      <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import menuList from "./menuList";
import editDialogMixin from "@/mixins/editDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    menuList,
  },
  data() {
    return {
      data: {
        RoleId: 0,
        RoleName: "",
        Remark: "",
        Status: 1,
        DataRange: 0,
        Menus: [],
        RoleType: 0,
      },
      api: require("@/api/sy/role").default,
      rules: {
        RoleName: [
          { required: true, message: "角色名称不能为空", trigger: "change" },
        ],
        RoleType: [
          { required: true, message: "角色类型不能为空", trigger: "change" },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getRoleWithMenu(0).then((res) => {
        return this.$refs.menuList.setData(res.Data.Menus);
      });
    },
    onEditOpened(data) {
      
        console.log(data,"ss");
      return this.$refs.menuList.setData(data.Menus);
    },
    onBeforeSave() {
      let roleMenus = this.$refs.menuList.getCheckedRows();
      this.data.Menus = roleMenus;
      return true;
    },
    onSaved() {
      this.$refs.dialog.reset();
      this.$refs.dialog.isSaved = true;
      this.api.getRoleWithMenu(0).then((res) => {
        return this.$refs.menuList.setData(res.Data.Menus);
      });
    },
    onClosed() {
      this.$refs.menuList.reset();
    },
  },
};
</script>
<style lang="scss">
.setMargin {
  .el-form-item__label {
    padding-left: 15px;
  }
  .el-radio {
    margin-bottom: 10px;
  }
}
</style>